/**
 * Web mock for react-native-health-connect (Android) - not used on web
 */
module.exports = {
  initialize: () => Promise.resolve(false),
  requestPermission: () => Promise.resolve([]),
  insertRecords: () => Promise.resolve([]),
  ExerciseType: { OTHER_WORKOUT: 0 },
};
